import {LeaveChannelModalProps} from './types'
import LeaveChannelPromiseModalView from './LeaveChannelPromiseModalView'
import React from 'react'
import {partChannel} from 'api/action/partChannel'
import {toast} from 'components/Toast'
import {useAppDispatch} from 'hooks'
import {useTranslation} from 'react-i18next'

const LeaveChannelPromiseModal = (props: LeaveChannelModalProps): React.ReactElement => {
    const {
        channelId, onResolve, onReject,
    } = props
    const {t} = useTranslation()
    const dispatch = useAppDispatch()
    const [inProgress, setInProgress] = React.useState(false)

    const onConfirm = () => {
        setInProgress(true)
        dispatch(partChannel({channel_id: channelId}))
            .unwrap()
            .then(
                () => {
                    onResolve?.()
                    toast.success(t('Channel left successfully'))
                }, () => {
                    onReject?.()
                    toast.success(t('Error leaving channel'))
                },
            )
            .finally(() => {
                setInProgress(false)
            })
    }
    return (
        <LeaveChannelPromiseModalView {...props} inProgress={inProgress} onResolve={onConfirm} />
    )
}

export default LeaveChannelPromiseModal
